// RSS COMMERCE — shared interactions (FAQ accordion)
// Ported from rss-commerce-demo/assets/js/app.js. Scoped per-instance so the
// section can be added more than once in the theme editor.
(function () {
  'use strict';

  function initFaq(root) {
    var toggles = root.querySelectorAll('[data-rss-faq-toggle]');

    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var index = btn.getAttribute('data-rss-faq-toggle');
        var answer = root.querySelector('[data-rss-faq-answer="' + index + '"]');
        var chevron = btn.querySelector('[data-rss-faq-chevron]');
        var isOpen = btn.getAttribute('aria-expanded') === 'true';

        toggles.forEach(function (b) {
          b.setAttribute('aria-expanded', 'false');
          var c = b.querySelector('[data-rss-faq-chevron]');
          if (c) c.classList.remove('is-open');
        });
        root.querySelectorAll('[data-rss-faq-answer]').forEach(function (a) {
          a.hidden = true;
        });

        if (!isOpen) {
          btn.setAttribute('aria-expanded', 'true');
          if (chevron) chevron.classList.add('is-open');
          if (answer) answer.hidden = false;
        }
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-rss-faq]').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
